/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import InterventionListCard from './InterventionListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'

function InterventionListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'interventions',
    defaultMessage: 'Interventions'
  })

  const [searchParams, setSearchParams] = useQueryParams()

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <InterventionListCard
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default InterventionListPage
